// extracted by mini-css-extract-plugin
export default {"wrapper":"Mainboard_wrapper__KYGrz","dataBoardWrapper":"Mainboard_dataBoardWrapper__-30cH","numData":"Mainboard_numData__ywa4w"};